/**
 * desc : 图片展示样式-平铺
 */
<template>
  <section class="comp-image-tiled" :style="`background-color: ${backgroundColor}`">
    <div v-for="(image, index) in imgs" :key="index" data-actionid="1" data-itemtext="图片类组件" :data-itemotherinfo="getLink(image)" v-show="image.show"
      @touchstart="touchStart(image)"
      @touchmove="touchMove"
      @touchend="touchEnd(image, index)"
    >
      <img width="100%" :src="`${picHost+image.imgLink}`" @load="loadHandler">
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import mixin from './image_mixin.js'
import { eventBus } from '@/utils'
import urlHelper from '@lib/utils/urlHelper'
import pwaGlobalConfig from '@/utils/pwaGlobalConfig'

export default {
  mixins: [mixin],
  computed: {
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      }
    }
  },
  mounted() {
    const { env } = pwaGlobalConfig
    const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    const { reloadfix, id, fixqr }= this.$route.query
    const reloadList = ['T20220725103646', 'T20220826113600', 'T20220920210340', 'T20220830191722']
    // bugfix: TOC-2683
    // 小程序下vue-router使用histroy问题，长按不能识别二维码
    // reload后才行, 得使用 location.replace，用location.href会产生一条历史记录操作返回会回到错误页面
    if (reloadList.indexOf(id) > -1 && isIos && !reloadfix) {
      window.location.replace(`/modules?id=${id}&reloadfix=1`)
    } else if (fixqr && isIos && env.isTujiaMp) {
      let queryObjs = urlHelper.queryStrings()
      queryObjs.fixqr = ''
      const url = `/modules?${urlHelper.getStringByObject(queryObjs)}`
      window.location.replace(url)
    }
  },
  methods: {
    loadHandler($event) {
      eventBus.$emit('imageOnload')
    },
    //长按事件（起始）
    touchStart(image) {
      this.timeOutEvent = setTimeout(() => {
        this.longPress(image);
      }, 500); //这里设置定时器，定义长按500毫秒触发长按事件
      return false;
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    touchEnd(image, index) {
      clearTimeout(this.timeOutEvent); //清除定时器
      if (this.timeOutEvent != 0) {
        this.clickHandle(image, index)
      }
      return false;
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    touchMove() {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    longPress(image) {
      this.timeOutEvent = 0;
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_TRAVELAROUND_ELEMNT_CLICK',
        ext: {
          elementId: this.compId,
          elementName: '图片',
          elementType: 2,
          url: 'https://pic.tujia.com' + image.imgLink,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.comp-image-tiled {
  width: 100%;
  display: flex;
  > div {
    width: 100%;
    font-size: 0;
  }
  img {
    // cursor: pointer;
    // pointer-events: none;
    // -webkit-user-select: none;
    // -moz-user-select: none;
    // user-select: none;
  }
}
</style>
